'use client';

import { c as _c } from "react/compiler-runtime";
import AuthWidgetContext from '@shared/utils/context/AuthWidgetContext';
import { getInitialUserFromCookie } from '@shared/utils/helpers/parseJwt';
import useAuth from '@shared/utils/hooks/useAuth';
import { useContext } from 'react';
import { client, service } from '../utils/trpc';

// OAuth is create-or-login. A null onboardingPath = a fresh account: onboard it
// like a signup, starting with the verify step. Shared by the signup form and
// login modal.
export const useFinishOAuth = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      client,
      service
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    initializeUser
  } = useAuth(t0);
  const {
    openVerifyOffer
  } = useContext(AuthWidgetContext);
  let t1;
  if ($[1] !== initializeUser || $[2] !== openVerifyOffer) {
    t1 = async close => {
      const isNewUser = getInitialUserFromCookie()?.onboardingPath == null;
      if (!isNewUser) {
        close();
        return;
      }
      await client.onboarding.trackEvent.mutate({
        type: "TOUR_COMPLETED",
        meta: "activation"
      });
      await initializeUser();
      close();
      openVerifyOffer();
    };
    $[1] = initializeUser;
    $[2] = openVerifyOffer;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};